























import cCard from '@/components/default/Card.vue';
import cDatagrid from '@/components/default/Datagrid.vue';
import cPopup from '@/components/default/Popup.vue';
import { DxDataGrid, DxForm, DxSelectBox, DxLookup } from 'devextreme-vue';
import { DxEditing, DxStateStoring, DxColumn } from 'devextreme-vue/data-grid';
import { DxSimpleItem, DxRequiredRule, DxGroupItem, DxItem, DxLabel } from 'devextreme-vue/form';
import { Component, Vue } from 'vue-property-decorator';
import { CreateRawMaterialGroupCommand, DeleteRawMaterialGroupCommand, RawMaterialGroupsClient, RawMaterialGroup, UpdateRawMaterialGroupCommand } from '@/data/web-api-client';

@Component({
  components: {
    DxDataGrid,
    DxEditing,
    DxStateStoring,
    cCard,
    cDatagrid,
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxItem,
    DxLabel,
    DxColumn,
    DxSelectBox,
    DxLookup,
  },
})
export default class RawMaterialGroupTable extends Vue {
  public rawMaterialGroups: any[] = [];
  public loading!: boolean;

  showDialog: boolean = false;

  private rawMaterialsGroupClient = new RawMaterialGroupsClient(undefined, this.$axios);

  private mounted() {
    this.getRawMaterialGroups();
  }

  private async getRawMaterialGroups() {
    this.rawMaterialGroups = await this.rawMaterialsGroupClient.getAll();
  }

  public addRow() {
    const table: any = this.$refs.grid;

    table.instance.addRow();
  }

  public initRow(e: any) {
    e.data.value = '';
  }

  refresh() {
    this.showDialog = false;

    try {
      this.gridInstance.refresh();
      this.$emit('refresh');
    } catch {}
  }

  public async createRow(e: any) {
    const RawMaterialGroup = e.data as RawMaterialGroup;

    await this.rawMaterialsGroupClient.createRawMaterialGroup(
      new CreateRawMaterialGroupCommand({
        name: RawMaterialGroup.name,
        margin: RawMaterialGroup.margin,
      })
    );

    this.gridInstance.cancelEditData();
    this.getRawMaterialGroups();
  }

  public async updateRow(e: any) {
    const RawMaterialGroup: RawMaterialGroup = Object.assign({}, e.oldData as RawMaterialGroup, e.newData);

    await this.rawMaterialsGroupClient.updateRawMaterialGroup(
      new UpdateRawMaterialGroupCommand({
        id: RawMaterialGroup.id,
        name: RawMaterialGroup.name,
        margin: RawMaterialGroup.margin,
      })
    );

    this.gridInstance.cancelEditData();
    this.getRawMaterialGroups();
  }

  public async deleteRow(e: any) {
    await this.rawMaterialsGroupClient.deleteRawMaterialGroup(new DeleteRawMaterialGroupCommand({ rawMaterialGroupId: e.data.id }));

    this.getRawMaterialGroups();
    e.cancel = true;
  }

  get columns() {
    return [
      {
        dataField: 'name',
        caption: this.$t('objects.projects.statusObj.Name'),
        datatype: 'string',
      },
      {
        dataField: 'margin',
        caption: 'Marge',
        datatype: 'number',
      },
    ];
  }

  get gridInstance() {
    return (this.$refs.grid as DxDataGrid).instance!;
  }
}
